module.exports = __webpack_public_path__ + "img/s1_t1_28.06ad4da1.jpeg";